import { useMemo, useState } from "react";
import { IHttpService, HttpService } from "../../../../services/httpService";
import { INotifierService, NotifierService } from "../../../../services/notifierService";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { serviceShareInputUpdateRequestModelValidationSchema } from "../validations/serviceShareInputUpdateRequestModelValidationSchema";
import { IServiceShareInputUpdateRequestModel } from "../models/serviceShareInputUpdateRequestModel";

export const useUpdateServiceShareInputForm = (id: number, triggerRefetch: () => void, closeForm: () => void) =>{
    const httpService: IHttpService = useMemo(() => new HttpService(), []);
	const notifierService: INotifierService = useMemo(
		() => new NotifierService(),
		[]
	);

    const [isDefaultValuesLoading, setIsDefaultValuesLoading] = useState<boolean>(false);
	const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false);

    const {
		control,
		handleSubmit,
		watch,
		trigger,
		reset,
		formState: { isValid }
	} = useForm<IServiceShareInputUpdateRequestModel>({
		defaultValues: async () => {
			setIsDefaultValuesLoading(true);

            const response = await httpService
			.get<IServiceShareInputUpdateRequestModel>(
				`serviceShareInputs/getById?id=${id}`,
				undefined
			)

			setIsDefaultValuesLoading(false);

            if(!response){
                notifierService.warn("Cannot find record in database. Please refresh page.")
                closeForm();
            }

            return  {
                id: response.id,
                distributorOrEntity: response.distributorOrEntity,
                numberOfEmployees: response.numberOfEmployees,
                numberOfTechnicians: response.numberOfTechnicians,
                fridgeTechnicians: response.fridgeTechnicians,
                channel: response.channel,
                countryId: response.countryId,
                quarter: response.quarter,
                year: response.year,
                brandId: response.brandId
            }
        },
		resolver: yupResolver(serviceShareInputUpdateRequestModelValidationSchema()),
		mode: 'onChange',
		reValidateMode: 'onChange'
	});

	const formValues = watch();

    const onSubmitRequest = async (): Promise<void> => {
		trigger();

		if(!isValid){
			return;
		}

		setIsFormSubmitting(true);

		try {
			await httpService.post(
				'serviceShareInputs/update',
				JSON.stringify(formValues),
				undefined,
				false
			);

			triggerRefetch();

			reset();
			closeForm();
			
			notifierService.info("Item is successfully updated!");
		} catch (err) {
			notifierService.error("Cannot process the request. Please try again.");
		} finally {
			setIsFormSubmitting(false);
		}
	};

    return {
        control,
        isDefaultValuesLoading,
		isFormSubmitting,
        handleSubmitRequest: handleSubmit(onSubmitRequest),
    }
}
